import { Colors, Lightning } from "@lightningjs/sdk";
import theme from "../../../../../lib/theme";
import { Icon } from "../../../../../components/data-display/Icon/Icon";
import { Theme, themeManager } from "../../../../../components/configurations/Theme/ThemeManager";

interface SettingsListItemTemplateSpec extends Lightning.Component.TemplateSpec {
    label: string;
    isSelected: boolean;
    Icon: typeof Icon;
    Label: object;
}

export class SettingsListItem
    extends Lightning.Component<SettingsListItemTemplateSpec>
    implements Lightning.Component.ImplementTemplateSpec<SettingsListItemTemplateSpec>
{
    _label!: string;
    _value!: string;

    readonly Icon = this.getByRef("Icon")!;
    readonly Label = this.getByRef("Label")!;
    private _themeCallback!: (theme: Theme | undefined) => void;


    static override _template(): Lightning.Component.Template<SettingsListItemTemplateSpec> {
        return {
            collision: true,
            zIndex: 10,
            Icon: {
                w: 32,
                h: 32,
                x: 0,
                y: (h) => h / 2 - 4,
                mountY: 0.5,
                type: Icon,
                colorValue: theme.colors.text.secondary,
                icon: "check",
                iconWidth: 32
            },
            Label: {
                x: 42,
                y: (h) => h / 2,
                mountY: 0.5,
                text: {
                    fontSize: 28,
                    textColor: Colors(theme.colors.text.secondary).get(),
                    fontFace: "SemiBold"
                }
            }
        };
    }

    override _init(): void {
        this._themeCallback = this._onThemeChange.bind(this);
        themeManager.subscribe(this._themeCallback);
    }

    private _onThemeChange(customTheme: Theme | undefined): void {
        this.Label.patch({
            text: {
                textColor: customTheme?.title ?? Colors(theme.colors.text.secondary).get()
            }
        });
    }

    override _detach(): void {
        themeManager.unsubscribe(this._themeCallback);
    }

    override _getFocused() {
        return this.Icon
    }

    static get width() {
        return 1000;
    }

    static get height() {
        return theme.settings.item.h;
    }

    set isSelected(value: boolean) {
        this.Icon.patch({
            alpha: value ? 1 : 0.01
        });
    }

    set label(value: string) {
        this._label = value;
        this.Label.patch({
            text: {
                text: value
            }
        });
    }

    get label() {
        return this._label;
    }

    set value(value: string) {
        this._value = value;
    }

    get value() {
        return this._value;
    }

    override _focus() {
        const customTheme = themeManager.getTheme();
        this.Label.patch({
            text: {
                textColor: customTheme?.interaction ?? Colors(theme.colors.text.accent).get()
            }
        });
    }

    override _unfocus() {
        const customTheme = themeManager.getTheme();
        this.Label.patch({
            text: {
                textColor: customTheme?.title ?? Colors(theme.colors.text.secondary).get()
            }
        });
    }

    override _handleEnter() {
        this.fireAncestors("$optionSelected", this._value);
    }

    _handleClick() {
        this._handleEnter();

        this.focusIn();
    }

    focusIn() {
        const list = this.parent?.parent?.parent;

        // @ts-expect-error no types available yet,
        list.setIndex(this.parent.componentIndex);
    }
}
